import { connect } from 'react-redux';
import NavBar from '../../../components/PageStructure/NavBar/NavBar';

const mapStateToProps = ({
  global: {
    router: { location },
  },
}) => {
  const { pathname } = location;
  return {
    currentPathname: pathname,
  };
};
const NavBarContainer = connect(
  mapStateToProps,
  null,
)(NavBar);

export default NavBarContainer;
